
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/srv/www/uia-frontend/sentry.client.config.ts")
            }
          });